import React from 'react';
import { addErrorToReport } from '@americanexpress/one-app-ducks';
import oneAppModuleWrapper from '@americanexpress/one-app-module-wrapper';
import { ReportModuleBlockingError } from '@americanexpress/travel-error-base';
import { Surface } from '@americanexpress/dls-react';
import { clsx } from 'clsx';
import AdditionalBanner from './AdditionalBanner/AdditionalBanner';
import AdvisoryBanner from './AdvisoryBanner/AdvisoryBanner';
import { loadAdvisoryOneCMS, useAdvisoryOneCMS } from '../fetchye/advisoryOneCMSFetchye';
import { moduleName } from '../constants/moduleName';
import styles from './TravelAdvisory.scss';

const FETCH_404_MESSAGE = 'Fetch Error: response was not ok, received status 404';

const TravelAdvisory = () => {
  const { isLoading, error } = useAdvisoryOneCMS();

  if (isLoading || error?.message === FETCH_404_MESSAGE) {
    return null;
  }

  if (error) {
    return (
      <ReportModuleBlockingError
        moduleID={moduleName}
        otherData={{
          causes: {
            oneCmsLoad: !!error,
            message: error.message,
            error,
          },
        }}
      />
    );
  }

  return (
    <Surface className={clsx('container pad-0 radius-container', styles.zIndexControl)} variant="foreground">
      <AdvisoryBanner />
      <AdditionalBanner />
    </Surface>
  );
};

export const loadModuleData = async ({ store: { dispatch } }) => {
  try {
    const resolution = await Promise.allSettled([
      dispatch(loadAdvisoryOneCMS),
    ]);
    await Promise.all(resolution.filter((result) => result.status === 'rejected')
      .map(async (result) => {
        dispatch(addErrorToReport(result.reason, {
          collectionMethod: 'loadModuleData rejected',
          moduleID: moduleName,
          caught: true,
        }));
      }));
  } catch (e) {
    dispatch(addErrorToReport(e, {
      collectionMethod: 'loadModuleData error',
      moduleID: moduleName,
      caught: false,
    }));
  }
};

export { TravelAdvisory as TestableTravelAdvisory };

TravelAdvisory.holocron = {
  name: moduleName,
  loadModuleData,
};

const hocChain = oneAppModuleWrapper(moduleName);

export default hocChain(TravelAdvisory);
